import appConfig from '../../../config/appConfig';
import urlUtils from '../../../utils/urlUtils';
import ApiClient from './apiClient';

export default class ModulesHostApiClient extends ApiClient {
    getApiUrl(methodName) {
        const apiUrl = appConfig.getModulesHostApiUrl();

        return urlUtils.join(apiUrl, methodName);
    }
}
